export default __webpack_public_path__ + "static/loader-e145122b66360d715623f76f6584ffc6.gif";